import { injectable } from "inversify";
import { DiContainerInjectFn } from "../di/ts";
import { LogisticsDataService } from "./services/logistics.service";

export default ((container) => {
    container.bind(LogisticsDataService).to(LogisticsDataService).inSingletonScope();
  }) as DiContainerInjectFn;